import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TmetricActions = {
  tmetricSaveApiKey: async (_, payload) => {
    return axiosRequest.
      post('/users/tmetric/create', {
        api_key: payload,
      }).
      catch(handleError)
  },

  tmetricRemoveApiKey: async _ => {
    return axiosRequest.
      delete('/users/tmetric/delete').
      catch(handleError)
  },

  tmetricStartTimeEntry: async (_, payload) => {
    return axiosRequest.
      post('/users/tmetric/time_entries', { time_entry: payload }).
      catch(handleError)
  },

  tmetricStopTimeEntry: async (_, { id }) => {
    return axiosRequest.
      patch(
        `/users/tmetric/time_entries/${id}/update`,
        { time_entry: { endTime: Date.now() } }
      ).
      catch(handleError)
  },

  tmetricFetchProjects: async ({ commit }) => {
    return axiosRequest.
      get('/users/tmetric/projects').
      then(response => commit('setTmetricProjects', response.data)).
      catch(handleError)
  },

  tmetricFetchTags: async ({ commit }) => {
    return axiosRequest.
      get('/users/tmetric/tags').
      then(response => commit('setTmetricTags', response.data)).
      catch(handleError)
  },
}

export const TmetricGetters = {
  tmetricProjects: state => state.tmetricProjects,
  tmetricTags: state => state.tmetricTags,
}

export const TmetricMutations = {
  setTmetricProjects: (state, projects) => { state.tmetricProjects = projects },
  setTmetricTags: (state, tags) => { state.tmetricTags = tags },
}

export const TmetricState = {
  tmetricProjects: [],
  tmetricTags: [],
}
